module.exports = __webpack_public_path__ + "img/career-fair.8748783f.svg";